module.exports = __webpack_public_path__ + "static/media/3_Pre-Check Doorbell Size-Right.1b8b348e.svg";